// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_jv-0";
export var discountCodeInput = "_jv-1";